<template>

    <!-- Transparent overlay -->
    <div v-if="menuExpanded" class="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden" @click="closeMenu"></div>

    <aside id="default-sidebar" class="fixed top-0 left-0 z-40 w-64 h-screen transition-transform md:translate-x-0"
        aria-label="Sidebar" :class="{ '-translate-x-full': !menuExpanded }">
        <div class="h-full px-3 py-4 overflow-y-auto bg-gray-100 dark:bg-gray-800">
            <ul class="space-y-2 font-medium">
                <li :class="{ 'bg-teal-100 dark:bg-teal-800 rounded cursor-default': isActive('/app/clients') }">
                    <nuxt-link to="/app/clients"
                        class="flex items-center p-2 text-gray-900 rounded dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 group">
                        <icon-users
                            class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                        <span class="flex-1 ms-3 whitespace-nowrap">Clients</span>
                    </nuxt-link>
                </li>
                <li :class="{ 'bg-teal-100 dark:bg-teal-800 rounded cursor-default': isActive('/app/reports') }">
                    <nuxt-link to="/app/reports" class="flex items-center p-2 text-gray-900 rounded dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 group">
                        <icon-inbox class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                        <span class="flex-1 ms-3 whitespace-nowrap">Reports</span>
                        <!--
                        <span class="inline-flex items-center justify-center w-3 h-3 p-3 ms-3 text-sm font-medium text-blue-800 bg-teal-100 rounded-full dark:bg-teal-800 dark:text-blue-300">3</span>
                        -->
                    </nuxt-link>
                </li>
                <li :class="{ 'bg-teal-100 dark:bg-teal-800 rounded cursor-default': isActive('/app/pricing') }">
                    <nuxt-link to="/app/pricing"
                        class="flex items-center p-2 text-gray-900 rounded dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 group">
                        <icon-coin
                            class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                        <span class="flex-1 ms-3 whitespace-nowrap">Pricing</span>
                    </nuxt-link>
                </li>
                <li :class="{ 'bg-teal-100 dark:bg-teal-800 rounded cursor-default': isActive('/app/users') }">
                    <nuxt-link to="/app/users"
                        class="flex items-center p-2 text-gray-900 rounded dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 group">
                        <icon-user
                            class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                        <span class="flex-1 ms-3 whitespace-nowrap">Users</span>
                    </nuxt-link>
                </li>
            </ul>
        </div>
    </aside>
</template>

<script setup lang="ts">

import IconInbox from "~/components/icons/icon-inbox.vue";
import { useUserStore } from "~/stores/userStore";
import IconCoin from "~/components/icons/icon-coin.vue";
import IconUsers from "~/components/icons/icon-users.vue";
import IconUser from "~/components/icons/icon-user.vue";

const userStore = useUserStore()
const route = useRoute();

const menuExpanded = computed(() => userStore.menuExpanded);

const closeMenu = () => {
    userStore.menuExpanded = false;
}

const isActive = (path: string) => {
  if (path === '/app/reports') {
    return route.path === '/app/reports' || route.path.startsWith('/app/report/');
  }
  
  return route.path.startsWith(path);
};
</script>


<style scoped></style>